  let isCompatibilityEventInitialized = false;
  
  document.querySelectorAll('.compatibility-block').forEach((btn) => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      
      document.querySelector('#popup').classList.remove('hidden');

      if (!isCompatibilityEventInitialized) {
        isCompatibilityEventInitialized = true;
        initCompatibilityEvent();
      }
    });
  });


    function initCompatibilityEvent(){
      console.log("onLoad")
      const steps = document.querySelectorAll("div#popup .content .block");
      var data = {
        "os" : "",
        "puce_mac" : "",
        "puce_windows": "",
        "size" :"",
        "connectiques" : "",
        "admin" : ""
      };
      document.querySelectorAll('.container_item').forEach(item => {
          item.addEventListener('click', function(e) {
              e.stopPropagation();
              let radio = this.querySelector('input[type="radio"]');
              if (radio) {
                  radio.checked = true;
              }
          });
      });
      document.querySelectorAll('.container_item input[type="radio"]').forEach(input => {
          input.addEventListener('click', function(e) {
              e.stopPropagation(); // Empêche le clic de remonter
              this.checked = true;
          });
      });
      document.querySelectorAll('.connectivity-option').forEach(item => {
          item.addEventListener('click', function(e) {
            e.stopPropagation();
              let radio = this.querySelector('input[type="radio"]');
              if (radio) {
                  radio.checked = true;
              }
          });
      });
      document.querySelectorAll('.connectivity-option input[type="radio"]').forEach(input => {
          input.addEventListener('click', function(e) {
              e.stopPropagation(); // Empêche le clic de remonter
              this.checked = true;
          });
      });
      document.querySelectorAll('.container_btn_col label').forEach(item => {
          item.addEventListener('click', function(e) {
            e.stopPropagation();
              let radio = this.querySelector('input[type="radio"]');
              if (radio) {
                  radio.checked = true;
              }
          });
      });
      document.querySelectorAll('.container_btn_col label input[type="radio"]').forEach(input => {
          input.addEventListener('click', function(e) {
              e.stopPropagation(); // Empêche le clic de remonter
              this.checked = true;
          });
      });
      
      document.querySelector("span.close-second-btn").addEventListener('click', function(e) {
        e.stopPropagation(); 
          document.querySelector(".second_popup").classList.add("hide");
      });
      document.querySelector("button#close_second_popup").addEventListener('click', function(e) {
        e.stopPropagation(); 
          document.querySelector(".second_popup").classList.add("hide");
      });
    document.querySelectorAll(".close_popup").forEach(function(element) {
        element.addEventListener('click', function(e) {
            e.stopPropagation();
            closePopup();
        });
    });
      
      document.querySelector(".infobule.blue strong").addEventListener('click', function(e) {
        e.stopPropagation(); 
        document.querySelector(".second_popup").classList.remove("hide");
      });
     const slider = document.getElementById("rangeSlider");
      const input = document.getElementById("sliderValue");
      const container_input = document.getElementById("container_input_value");
      const inputMobile = document.querySelector("input#sliderValueMobile");
      const container_input_mobile = document.querySelector("span#sliderValueMobile");
      // Met à jour l'input lorsque le slider change
      slider.addEventListener("input", function() {
          input.value = parseFloat(slider.value).toFixed(1).replace(".", ",");
          inputMobile.value = parseFloat(slider.value).toFixed(1).replace(".", ",");
          container_input_mobile.textContent = parseFloat(slider.value).toFixed(1).replace(".", ",") + " cm";
          updatePosition();
      });
      inputMobile.addEventListener("input", function() {
          let newValue = inputMobile.value.replace(",", ".");
          if (!isNaN(newValue) && newValue >= slider.min && newValue <= slider.max) {
              slider.value = newValue;
              updatePosition();
          }
      });
      inputMobile.addEventListener("blur", function() {
          let newValue = parseFloat(inputMobile.value.replace(",", "."));
          if (isNaN(newValue) || newValue < slider.min || newValue > slider.max) {
              input.value = parseFloat(slider.value).toFixed(1).replace(".", ",");
              inputMobile.value = parseFloat(slider.value).toFixed(1).replace(".", ",");
              container_input_mobile.value = parseFloat(slider.value).toFixed(1).replace(".", ",");
              updatePosition();
          }
      });
      
      // Met à jour le slider lorsque l'input change
      input.addEventListener("input", function() {
          let newValue = input.value.replace(",", ".");
          if (!isNaN(newValue) && newValue >= slider.min && newValue <= slider.max) {
              slider.value = newValue;
              updatePosition();
          }
      });
    
      // Corrige la valeur entrée si elle est invalide
      input.addEventListener("blur", function() {
          let newValue = parseFloat(input.value.replace(",", "."));
          if (isNaN(newValue) || newValue < slider.min || newValue > slider.max) {
              input.value = parseFloat(slider.value).toFixed(1).replace(".", ",");
              inputMobile.value = parseFloat(slider.value).toFixed(1).replace(".", ",");
              container_input_mobile.value = parseFloat(slider.value).toFixed(1).replace(".", ",");
              updatePosition();
          }
      });
       function updatePosition() {
          let value = ((slider.value - slider.min) / (slider.max - slider.min)) * 100;
          let offset = (value / 100) * 70; // Interpolation entre 0px et 70px
          container_input.style.left = `calc(${value}% - ${offset}px)`;
          // input.value = parseFloat(slider.value).toFixed(1).replace(".", ",");
      }
      document.getElementById("next-btn").addEventListener("click", function(e){
        e.preventDefault();
        const step = this.dataset.step;
        if(step == 1){
          show_hide_buttons("true");
          let radio = document.querySelector('[name="os_select"]:checked');
          if(radio){        
            let is_apple = radio.dataset.apple;
            let is_widows = radio.dataset.windows;
            let os = radio.dataset.os;
            data.os = os;
            if(is_apple == "true"){        
              goToStep(1.5);
            }else if(is_widows == "true"){        
              goToStep(1.2);
            }else{ 
              data.puce_windows = "false";
              data.puce_mac = "false";
              goToStep(2);       
            }  
          }else{
            alert("merci de sélectionner un OS");
          }
        }else if(step == 1.2){
          show_hide_buttons("true");
          data.puce_windows = document.querySelector('input[name="puce_windows_select"]:checked').value;
          goToStep(2); 
        }else if(step == 1.5){
          show_hide_buttons("true");
          data.puce_mac = document.querySelector('input[name="puce_mac_select"]:checked').value;
          goToStep(2);      
        }else if(step == 2){
          show_hide_buttons("true");
          data.size = document.querySelector("input#rangeSlider").value;
          goToStep(3);   
        }else if(step == 3){      
          show_hide_buttons("true");
          data.connectiques = document.querySelector('input[name="connectivite_select"]:checked').value;
          goToStep(4);    
        }else if(step == 4){
            data.admin = document.querySelector('input[name="admin_select"]:checked').value;
            goToStep(5);    
            show_hide_buttons("false");
            console.log(data)
            const compatibleItems = filterCompatibleProducts(data);
            console.log(compatibleItems);
        }else if(step == 5){      
        }
      });
      function filterCompatibleProducts(userData) {
        const results = document.querySelectorAll('.result_item');
        const compatibleProducts = [];
        const initialProduct = [];
        results.forEach(item => {
          const itemOS = item.dataset.compatible_os;
          const minScreenSize = parseFloat(item.dataset.min_screen_size);
          const maxScreenSize = parseFloat(item.dataset.max_screen_size);
          const itemConnectivity = item.dataset.connectivity;
          const is_the_product = item.dataset.is_the_product;
          const adminRequired = item.dataset.admin_rights_required === 'true';
          // Vérifier l'OS
          const isOSCompatible = itemOS.includes(userData.os);
          const isSurfacePro = userData.puce_windows && userData.puce_windows.includes("Surface");
          // Vérifier la taille d'écran
          const userScreenSize = parseFloat(userData.size);
          const isScreenSizeCompatible = (userScreenSize >= minScreenSize) && (userScreenSize <= maxScreenSize);
          // Vérifier les connectiques
          const isConnectivityCompatible = itemConnectivity.includes(userData.connectiques);
      
          // Vérifier les droits admin
          const isAdminCompatible = !adminRequired || (adminRequired && (userData.admin === 'Oui' || userData.admin === 'yes' || userData.admin === 'Yes' || userData.admin === 'Ja' || userData.admin === '\nJa' || userData.admin === 'ja'));
          // Vérifier toutes les conditions
          if (isOSCompatible && isScreenSizeCompatible && isConnectivityCompatible && isAdminCompatible) {
            if(is_the_product == "true" ){
              initialProduct.push(item);
            }else{
              compatibleProducts.push(item);
            }
            item.classList.add("enable");
          }
          if(initialProduct.length > 0){
            if(isSurfacePro){          
              hide_show_title_results("resultat_positif");
              document.querySelectorAll('.result_item').forEach(item => {item.classList.remove("enable"); });
              document.querySelector('.result_item[data-is_the_product_surface="true"]').classList.add("enable");
            }else{          
              hide_show_title_results("resultat_positif");
              document.querySelectorAll('.result_item').forEach(item => {item.classList.remove("enable"); });
              document.querySelector('.result_item[data-is_the_product="true"]').classList.add("enable");
            }
          }else{
            if(compatibleProducts.length == 2){
              hide_show_title_results("resultat_negatif");
              document.querySelector('.result_item[data-is_the_product="true"]').classList.remove("enable");
            }else if (compatibleProducts.length == 1){
              hide_show_title_results("resultat_semi_negatif");
              document.querySelector('.result_item[data-is_the_product="true"]').classList.remove("enable");
            }else{
              
            }
          }
        });
      
        return [initialProduct,compatibleProducts];
      }
      function hide_show_title_results(item){
        document.querySelectorAll(".product_title").forEach(item_title => {
          item_title.classList.add("hide")
        });
        document.querySelector('.product_title[data-product_title="'+item+'"]').classList.remove("hide");
      }
      function show_hide_buttons(status){
        const buttons_popup = document.querySelector(".buttons.popup.main");
        if(buttons_popup ){      
          if(status == "true"){
            buttons_popup.classList.remove("hidden");
          }else{      
            buttons_popup.classList.add("hidden")
          }
        }
      }
      document.getElementById("prev-btn").addEventListener("click", function(){
        
        const step = this.dataset.step;
        if(step == 1){ 
          goToStep(1);     
        }else if(step == 1.2){
          goToStep(1);          
        }else if(step == 1.5){
          goToStep(1);          
        }else if(step == 2){
          if(data.puce_windows != "false"){
            goToStep(1.2); 
          }else if(data.puce_mac != "false"){
            goToStep(1.5); 
          }else{
            goToStep(1); 
          }         
        }else if(step == 3){
          goToStep(2);          
        }else if(step == 4){
          goToStep(3);      
        }
      });
      document.querySelector(".close-btn").addEventListener("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        closePopup();
      });
      document.querySelector("div#popup").addEventListener("click", function() {
        closePopup();
      });
      document.querySelector(".popup-content").addEventListener("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        document.getElementById("popup").classList.remove("hidden");
      });
      document.querySelectorAll(".popup-content a").forEach(item => {
          item.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            var url = this.getAttribute("href"); // Récupère l'URL du lien
            if (url) {
              window.location.href = url; // Redirige vers l'URL
            }
          });
      });
    
      function goToStep(new_step) {
        document.querySelector(".steps-indicator").setAttribute("data-step",new_step);
        document.querySelectorAll("#popup .block").forEach(item => {
          item.classList.remove("active");
        });
        document.querySelectorAll("#popup .steps-indicator .step").forEach(item => {
          item.classList.remove("active");
        });
        document.querySelector('#popup .block[data-step="'+new_step+'"]').classList.add("active");
        for(let i=1; i <= new_step; i++){
          if(document.querySelector('#popup .steps-indicator .step[data-step="'+i+'"]')){          
            document.querySelector('#popup .steps-indicator .step[data-step="'+i+'"]').classList.add("active");
          }
        }
        if(new_step != 1.5 && new_step != 1.2){  
          if(document.querySelector('#popup .steps-indicator .step[data-step="'+new_step+'"]')){          
            document.querySelector('#popup .steps-indicator .step[data-step="'+new_step+'"]').classList.add("active");
          }
        }
        updateButtons(new_step);
      }
    
      function updateButtons(currentStep) {
        document.getElementById("prev-btn").setAttribute("data-step",currentStep);
        document.getElementById("next-btn").setAttribute("data-step",currentStep);
        document.getElementById("prev-btn").classList.toggle("disable", currentStep <= 1);
        document.getElementById("next-btn").innerText = (currentStep == (steps.length - 2)) ? "Terminer" : "Continuer >";
      }
      function closePopup(){
        document.querySelector("#popup").classList.add("hidden");
        document.querySelector(".second_popup").classList.add("hide");
        data = {
          "os" : "",
          "puce_mac" : "",
          "size" :"",
          "connectiques" : "",
          "admin" : ""
        };
        goToStep(1);     
        show_hide_buttons("true"); 
        
      }
      
    }
